import Layout from '@/layout'

export const fn = [
  {
    path: '/fa/manage',
    component: Layout,
    redirect: '/fa/manage/resume',
    name: 'MessageManager',
    alwaysShow: true,
    meta: {
      title: '信息维护',
      icon: 'message-manager',
      permission_uri: '/fa/manage'
    },
    children: [
      {
        path: 'resume',
        name: 'Resume',
        component: () => import('@/views/fn/messageManager/resume'),
        meta: {
          title: '简历库',
          icon: 'archive-store',
          permission_uri: '/fa/manage/resume'
        }
      },
      {
        path: 'staff',
        name: 'StaffArchives',
        component: () => import('@/views/fn/messageManager/staffArchives'),
        meta: {
          title: '员工档案库',
          icon: 'archive-store',
          permission_uri: '/fa/manage/staff'
        }
      }, {
        path: 'sbu-staff',
        name: 'Organization',
        component: () => import('@/views/fn/messageManager/organization'),
        meta: {
          title: '组织架构',
          icon: 'organization',
          permission_uri: '/fa/manage/sbu-staff'
        }
      }, {
        path: 'exam-record',
        name: 'ExamRecord',
        component: () => import('@/views/fn/messageManager/examRecord'),
        meta: {
          title: '笔试记录',
          icon: 'exam-record',
          permission_uri: '/fa/manage/exam-record'
        }
      }, {
        path: 'exam-question',
        name: 'ExamQuestion',
        component: () => import('@/views/fn/messageManager/examQuestion'),
        meta: {
          title: '笔试题管理',
          icon: 'exam',
          permission_uri: '/fa/manage/exam-question'
        }
      }, {
        path: 'user-count',
        name: 'StaffCount',
        component: () => import('@/views/fn/dateManage/staffCount'),
        meta: {
          title: '组织架构人数',
          icon: 'user',
          permission_uri: '/fa/manage/user-count'
        }
      }, {
        path: 'formal-entry-notice',
        name: 'FormalEntryNotice',
        component: () => import('@/views/fn/messageManager/formalEntryNotice'),
        meta: {
          title: '转正提醒',
          icon: 'exam',
          permission_uri: '/fa/manage/formal-entry-notice'
        }
      }
    ]
  },
  {
    path: '/fa/attendance-rule',
    component: Layout,
    redirect: '/fa/attendance-rule/list',
    name: 'AttendanceRule',
    alwaysShow: true,
    meta: {
      title: '考勤',
      icon: 'attendance',
      permission_uri: '/fa/attendance-rule'
    },
    children: [
      {
        path: 'list',
        name: 'RuleList',
        component: () => import('@/views/fn/attendanceRule/ruleList'),
        meta: {
          title: '考勤排班',
          icon: 'attendance-rule',
          permission_uri: '/fa/attendance-rule/list'
        }
      }
    ]
  },
  {
    path: '/fa/attendance-config',
    component: Layout,
    redirect: '/fa/attendance-config/list',
    name: 'AttendanceConfig',
    alwaysShow: true,
    meta: {
      title: '规则配置',
      icon: 'attendance-config',
      permission_uri: '/fa/attendance-config'
    },
    children: [
      {
        path: 'list',
        name: 'List',
        component: () => import('@/views/fn/attendanceConfig/configList'),
        meta: {
          title: '系统配置',
          icon: 'allocation',
          permission_uri: '/fa/attendance-config/list'
        }
      },
      {
        path: 'manager',
        name: 'manager',
        component: () => import('@/views/fn/attendanceConfig/managerList'),
        meta: {
          title: '负责人配置',
          icon: 'allocation',
          permission_uri: '/fa/attendance-config/manager'
        }
      },
      {
        path: 'ot-config',
        name: 'OtConfigList',
        component: () => import('@/views/fn/attendanceConfig/otConfigList'),
        meta: {
          title: '弹性上班配置',
          icon: 'allocation',
          permission_uri: '/fa/attendance-config/ot-config'
        }
      },
      {
        path: 'annual-leave',
        name: 'annualLeaveList',
        component: () => import('@/views/fn/attendanceConfig/annualLeaveList'),
        meta: {
          title: '年假配置',
          icon: 'allocation',
          permission_uri: '/fa/attendance-config/annual-leave'
        }
      }
    ]
  },
  {
    path: '/fa/attendance-record',
    component: Layout,
    redirect: '/fa/attendance-record/list',
    name: 'AttendanceRecord',
    alwaysShow: true,
    meta: {
      title: '考勤记录',
      icon: 'attendance-record',
      permission_uri: '/fa/attendance-record'
    },
    children: [
      {
        path: 'list',
        name: 'RecordList',
        component: () => import('@/views/fn/attendanceRecord/recordList'),
        meta: {
          title: '汇总考勤记录',
          icon: 'record-list',
          permission_uri: '/fa/attendance-record/list'
        }
      },
      {
        path: 'detail',
        name: 'Detail',
        component: () => import('@/views/fn/attendanceRecord/recordDetail'),
        meta: {
          title: '考勤日志报表',
          icon: 'log',
          permission_uri: '/fa/attendance-record/detail'
        }
      },
      {
        path: 'personal',
        name: 'PersonalRecord',
        component: () => import('@/views/fn/attendanceRecord/recordPersonal'),
        meta: {
          title: '个人考勤日志',
          icon: 'personal-record',
          permission_uri: '/fa/attendance-record/personal'
        }
      },
      {
        path: 'personal-history',
        name: 'PersonalHistory',
        component: () => import('@/views/fn/attendanceRecord/personalHistory'),
        meta: {
          title: '个人历史考勤',
          icon: 'personal-record',
          permission_uri: '/fa/attendance-record/personal-history'
        }
      },
      {
        path: 'warn',
        name: 'Warn',
        component: () => import('@/views/fn/attendanceRecord/warn'),
        meta: {
          title: '未确认提醒',
          icon: 'log',
          permission_uri: '/fa/attendance-record/warn'
        }
      }
    ]
  },
  {
    path: '/fa/attendance-task',
    component: Layout,
    redirect: '/fa/attendance-task/run',
    name: 'task',
    alwaysShow: true,
    meta: {
      title: '考勤重算',
      icon: 'attendance-config',
      permission_uri: '/fa/attendance-task'
    },
    children: [
      {
        path: 'run',
        name: 'ConfigList',
        component: () => import('@/views/fn/attendanceTask/run'),
        meta: {
          title: '考勤重算',
          icon: 'allocation',
          permission_uri: '/fa/attendance-task/run'
        }
      }
    ]
  },
  {
    path: '/fa/basic',
    component: Layout,
    redirect: '/fa/basic/salary',
    name: 'Basic',
    alwaysShow: true,
    meta: {
      title: '基础数据',
      icon: 'base-data',
      permission_uri: '/fa/basic'
    },
    children: [
      {
        path: 'salary',
        name: 'BasicSalary',
        component: () => import('@/views/fn/baseData/salary'),
        meta: {
          title: '工资报表',
          icon: 'salary',
          permission_uri: '/fa/basic/salary'
        }
      },
      {
        path: 'cost',
        name: 'BasicCost',
        component: () => import('@/views/fn/baseData/cost'),
        meta: {
          title: '费用报表',
          icon: 'salary',
          permission_uri: '/fa/basic/cost'
        }
      }
    ]
  },
  {
    path: '/fa/share',
    component: Layout,
    redirect: '/fa/share/salary',
    name: 'Share',
    alwaysShow: true,
    meta: {
      title: '分摊报表',
      icon: 'share',
      permission_uri: '/fa/share'
    },
    children: [
      {
        path: 'salary',
        name: 'ShareSalary',
        component: () => import('@/views/fn/share/salary'),
        meta: {
          title: '工资分摊报表',
          icon: 'share-salary',
          permission_uri: '/fa/share/salary'
        }
      },
      {
        path: 'cost',
        name: 'ShareCost',
        component: () => import('@/views/fn/share/cost'),
        meta: {
          title: '费用分摊报表',
          icon: 'log',
          permission_uri: '/fa/share/cost'
        }
      }
    ]
  },
  {
    path: '/fa/workflow',
    component: Layout,
    redirect: '/fa/workflow/project',
    name: 'Workflow',
    alwaysShow: true,
    meta: {
      title: '审批',
      icon: 'workflow',
      permission_uri: '/fa/workflow'
    },
    children: [
      {
        path: 'permission',
        name: 'permission',
        component: () => import('@/views/fn/workflow/permission'),
        meta: {
          title: '可视权限配置',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/permission'
        }
      }, {
        path: 'department-bind-root-game',
        name: 'departmentBindRootGame',
        component: () => import('@/views/fn/workflow/departmentBindRootGame'),
        meta: {
          title: '部门关联根游戏',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/department-bind-root-game'
        }
      }, {
        path: 'project',
        name: 'Project',
        component: () => import('@/views/fn/workflow/project'),
        meta: {
          title: '项目确认',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/project'
        }
      }, {
        path: 'approval-pending',
        name: 'ApprovalPending',
        component: () => import('@/views/fn/workflow/approvalPending'),
        meta: {
          title: '待审批流程',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/approval-pending'
        }
      }, {
        path: 'approval-finished',
        name: 'ApprovalFinished',
        component: () => import('@/views/fn/workflow/approvalFinished'),
        meta: {
          title: '已结束流程',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/approval-finished'
        }
      }, {
        path: 'approval-rejected',
        name: 'ApprovalRejected',
        component: () => import('@/views/fn/workflow/approvalRejected'),
        meta: {
          title: '已驳回流程',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/approval-rejected'
        }
      }, {
        path: 'work-hour',
        name: 'WorkHour',
        component: () => import('@/views/fn/workflow/workHour'),
        meta: {
          title: '项目工时确认',
          icon: 'dashboard',
          permission_uri: '/fa/workflow/work-hour'
        }
      },
      {
        path: 'warn',
        name: 'Warn',
        component: () => import('@/views/fn/workflow/warn'),
        meta: {
          title: '未确认提醒',
          icon: 'log',
          permission_uri: '/fa/workflow/warn'
        }
      }
    ]
  },
  {
    path: '/fa/visualization',
    component: Layout,
    redirect: '/fa/visualization/profit',
    name: 'Visualization',
    alwaysShow: true,
    meta: {
      title: '数据可视化',
      icon: 'overview-data',
      permission_uri: '/fa/visualization'
    },
    children: [
      {
        path: 'profit',
        name: 'FAProfit',
        component: () => import('@/views/fn/visualization/profit'),
        meta: {
          title: '利润报表',
          icon: 'dashboard',
          permission_uri: '/fa/visualization/profit'
        }
      }
    ]
  },
  {
    path: '/fa/permission',
    component: Layout,
    redirect: '/fa/permission/member',
    name: 'FNPermission',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'permission',
      permission_uri: '/fa/permission'
    },
    children: [
      {
        path: 'member',
        name: 'FNPermissionMember',
        component: () => import('@/views/fn/permission/member'),
        meta: {
          title: '成员管理',
          icon: 'user',
          permission_uri: '/fa/permission/member'
        }
      }
    ]
  }
]
